import React, { Fragment, useEffect, useState, forwardRef } from "react";
import InputTextArea from "antd/es/input/TextArea";
import FormItem from "antd/es/form/FormItem";
import { Icon, Button, Row, Col } from "antd";
import unescape from "lodash/unescape";
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, questionsKey, language, onCheckAnswer, checkAnswer } = props,
    { required, questions, id, defaultValue, toolConfig, } = inputData,
    { getFieldDecorator, getFieldsValue } = form,
    { minChars } = toolConfig;
  const [disabled, setDisabled] = useState(false);
  const [value, setValue] = useState('');
  const dangerouslySetInnerHTML = unescape(questions[language]);

  useEffect(() => {
    if (checkAnswer) {
      onCheckAnswer(id, value, questionsKey);
      setDisabled(true);
    }
  }, [checkAnswer])

  return (
    <Fragment>
    <Row type="flex" justify="center">
      <Col span={16}>
        {
          dangerouslySetInnerHTML !== "<p><br></p>" ?
          <span style={{ textAlign: 'center' }}>
            <span dangerouslySetInnerHTML={{
                __html: dangerouslySetInnerHTML
              }}
            />
          </span> :
          null
        }
        <FormItem
          colon={false}
        >
          {getFieldDecorator(id, {
            initialValue: defaultValue,
            rules: [
              {
                required,
                message: "Required Field"
              }
            ],
          })(
            <Fragment>
              <InputTextArea
                ref={ref}
                autoSize={{ minRows: 8, maxRows: 8 }}
                disabled={disabled}
                onChange={(event:any) => setValue(event.target.value)}
                style={{ resize: "none" }}
              />
              { minChars > 0 &&
                <Fragment>
                  <Text>Please write at least {minChars} characters if you can. </Text>
                  <Text style={{ float: "right" }}>{value.length}/{minChars}</Text>
                </Fragment>
              }
            </Fragment>
          )}
        </FormItem>
      </Col>
    </Row>
    </Fragment>
  );
});
